import { render, staticRenderFns } from "./userGradeTask.vue?vue&type=template&id=194ff434&scoped=true&"
import script from "./userGradeTask.vue?vue&type=script&lang=js&"
export * from "./userGradeTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194ff434",
  null
  
)

export default component.exports